<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <the-filter :inputs="inputs" customName="الحالة" />
    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <!-- <div class="row mb-5">
          <div class="wrraper">
            <stats-card
              :title="$t('user_rewardsNum')"
              :number="statisticsItem.number"
            ></stats-card>
          </div>
        </div> -->
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <main class="magic-table-wrapper">
          <v-data-table
            class="thumb strip"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <!-- Start:: Users Routes -->
            <template v-slot:[`item.user_name`]="{ item }">
              <div v-if="item.user">
                <img class="image" :src="item.user.avatar" />
                <!-- @error="replaceImage" -->
                <span>
                  {{ item.user.full_name }}
                </span>
              </div>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <template v-slot:[`item.user_phone`]="{ item }">
              <div v-if="item.user.phone">
                {{ item.user.phone_code + "" + item.user.phone }}
              </div>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <template v-slot:[`item.admin_name`]="{ item }">
              <div v-if="item.admin">
                <img class="image" :src="item.admin?.avatar" />
                <!-- @error="replaceImage" -->
                <span>
                  {{ item.admin?.full_name }}
                </span>
              </div>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <template v-slot:[`item.admin_phone`]="{ item }">
              <div v-if="item.admin?.phone">
                {{ item.admin.phone_code + "" + item.admin?.phone }}
              </div>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>

            <template v-slot:[`item.reward`]="{ item }">
              <span v-if="item.reward_value">
                {{ item.reward_value }}
              </span>
              <span v-else>لا يوجد</span>
            </template>
            <template v-slot:[`item.reward_type`]="{ item }">
              <span v-if="item.reward_type == 'cash'">
                {{ $t("forms.labels.cash") }}
              </span>
              <span v-else>
                {{ $t("forms.labels.gift") }}
              </span>
            </template>
            <!-- <template v-slot:[`item.status`]="{ item }">
              <span v-if="item.status == 'pending'" class="status pending">
                {{ item.status }}
              </span>

              <span v-if="item.status == 'accepted'" class="status success">
                {{ item.status }}
              </span>
              <span v-if="item.status == 'rejected'" class="status canceled">
                {{ item.status }}
              </span>
            </template> -->
            <template v-slot:[`item.status`]="{ item }">
              <div class="action">
                <div
                  v-if="item.status == 'accepted' || item.status == 'rejected'"
                >
                  <span
                    v-if="item.status == 'rejected'"
                    class="status canceled"
                  >
                    مرفوض
                  </span>
                  <span v-if="item.status == 'accepted'" class="status success">
                    مقبول
                  </span>
                </div>
                <div
                  v-else
                  class="select-wrapper selecet_shadow mx-auto"
                  style="width: 200px"
                >
                  <div class="input_wrapper">
                    <v-select
                      label="قيد الانتظار"
                      solo
                      :items="orderStatusList(item.status)"
                      @input="changeStatus($event, item.id)"
                    ></v-select>
                  </div>
                </div>
              </div>
            </template>
            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon
                  v-if="helper_hasPermission('show')"
                  class="show"
                  small
                  @click="showItem(item)"
                >
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon> -->
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <div class="d-flex justify-content-between">
                <div
                  class="p-2 frm-action d-flex flex-row gap-2"
                  v-if="selected.length"
                >
                  <button class="export btn button_style_1">
                    <export-excel
                      :fetch="exportFields"
                      :meta="json_meta"
                      name="طلبات السحب"
                      worksheet="طلبات السحب"
                    >
                      Export <i class="fal fa-download"></i
                    ></export-excel>
                  </button>
                  <v-select
                    class="change_status_select"
                    label="تغير الحالة"
                    :items="orderStatusList('pending')"
                    @input="changeMultiStatus($event)"
                  ></v-select>
                </div>
              </div>

              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Start:: Text Content Modal -->
              <TextContentModal
                @toggleModal="controlReportReasonModalModal"
                :modalIsActive="reportReasonModalIsOpen"
                :title="$t('reportReason')"
                :textContent="reportReasonToShow"
              />
              <!-- End:: Text Content Modal -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container text-center mb-5 d-flex justify-content-end"
          >
            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";
// End:: Importing Modals

import theFilter from "@/components/Filters/TheFilter.vue";

export default {
  name: "UsersReports",

  components: {
    TextContentModal,
    theFilter,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.user_rewards.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.user_rewards.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Filter
      inputs: [
        {
          keyName: "status",
          statuses: [
            {
              id: "pending",
              name: "قيد الانتظار",
            },
            {
              id: "accepted",
              name: "مقبول",
            },
            {
              id: "rejected",
              name: "مرفوض",
            },
          ],
        },
      ],

      // ========== Loading
      loading: false,
      selected: [],
      user_types: [
        {
          text: "العملاء",
          value: "client",
        },
        {
          text: "المناديب",
          value: "driver",
        },
        {
          text: "المتاجر",
          value: "restaurant",
        },
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "العميل",
            align: "center",
            value: "user_name",
            sortable: false,
          },
          {
            text: "رقم هاتف العميل",
            align: "center",
            value: "user_phone",
            sortable: false,
          },
          {
            text: "الادارة",
            align: "center",
            value: "admin_name",
            sortable: false,
          },
          {
            text: "رقم هاتف الادارة",
            align: "center",
            value: "admin_phone",
            sortable: false,
          },
          {
            text: "نوع الجائزة",
            align: "center",
            value: "reward_type",
            sortable: false,
          },
          {
            text: "الجائزة",
            align: "center",
            value: "reward",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "center",
            value: "status",
            sortable: false,
          },
          // {
          //   text: "التحكم",
          //   value: "actions",
          //   sortable: false,
          //   align: "center",
          // },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    orderStatusItems() {
      return [
        {
          label: "في الانتظار",
          name: "pending",
        },
        {
          label: "تمت الموافقة",
          name: "accepted",
        },
        {
          label: "تم الرفض",
          name: "rejected",
        },
      ];
    },
  },

  methods: {
    exportFields() {
      let newData = [];
      this.selected.forEach((el) => {
        let newObject = {};
        newObject[`العميل`] = el.user.full_name;
        newObject[`الهاتف`] = el.user.phone;
        newObject[`رقم الحساب`] = el.account_number;
        newObject[`اسم البنك`] = el.bank_name;
        newObject[`مبلغ السحب`] = el.amount;
        newObject[`المبلغ قبل`] = el.balance;
        newObject[`المبلغ بعد`] = el.balance_after_withdraw;
        newObject[`الحالة`] =
          el.status == "pending" || !el.status
            ? "قيد الانتظار"
            : el.status == "completed"
            ? "مكتملة"
            : el.status == "rejected"
            ? "مرفوض"
            : "";
        newObject[`الموظف`] = el.accepted_by_user;
        newObject[`التاريخ`] = el.created_at;

        // newObject[`${this.$t("forms.labels.city")}`] = el.city;
        newData.push(newObject);
      });
      return newData;
    },
    changeStatus(currStatus, id) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      // submit_data.append("_method", "PUT");
      submit_data.append("status", currStatus);
      this.$axios({
        method: "POST",
        url: `user_rewards/${id}/accept`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          // this.$router.push({ path: "/user_rewardss/all-user_rewardss" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    changeMultiStatus(currStatus) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      submit_data.append("status", currStatus);

      if (this.selected.length) {
        this.selected.forEach((el, index) => {
          submit_data.append(`cash_requests[${index}]`, el.id);
        });
      }
      this.$axios({
        method: "POST",
        url: `cashout-requests/accepts`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          // this.$router.push({ path: "/user_rewardss/all-user_rewardss" });
          this.btnIsLoading = false;
          this.selected = [];
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    orderStatusList(status) {
      if (status == "pending") {
        return [
          {
            text: "قبول",
            value: "accepted",
          },
          { text: "رفض", value: "rejected" },
        ];
      }
    },
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/user_rewards/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/user_rewards/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/user_rewards/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `user_reports/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "user_rewards",
        params: {
          page: this.paginations.current_page,
          status: this.$route.query.status || undefined,
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.paginations.current_page = +e;
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, { page: e }),
        })
        .catch(() => {});
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.setRows();
    },
  },

  watch: {
    [`$route`](to, from) {
      const pageInQuery = this.$route.query.page
        ? +this.$route.query.page
        : 1;
      if (
        this.paginations.current_page !== pageInQuery ||
        to?.query?.status !== from?.query?.status
      ) {
        this.paginations.current_page = pageInQuery;
        this.setRows();
      }
    },
  },

  // ======= hooks
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.ling_to_user {
  &:hover {
    color: green;
  }
}
.change_status_select {
  border: 1px solid rgba(128, 128, 128, 0.444);
  padding: 0px 10px !important;
}
</style>
